export const styles = {
    container: {
        display: 'block',
        paddingTop: 12,
        paddingLeft: 13,
        height: 42,
        width: 42,
        borderRadius: '50%',
        boxSizing: 'border-box',
        background: '#060606',
    }
};

export type ComponentJSSClasses = typeof styles;
